import React, { useState } from "react";
import Top3 from "../components/Top3";
import MoneyMoves from "../components/MoneyMoves";
import DoNotDrop from "../components/DoNotDrop";
import Timeline from "../components/Timeline";
import TodoistTaskList from "../components/TodoistTaskList";
import MorningBrief from "../components/MorningBrief";
import AskOperator from "../components/AskOperator";
import InlineCapture from "../components/InlineCapture";
import BusinessPulse from "../components/BusinessPulse";
import WaitingOn from "../components/WaitingOn";
import EndOfDay from "../components/EndOfDay";
import EditableLabel from "../components/EditableLabel";
import { ChevronDown, ChevronUp } from "lucide-react";

const dateStr = () => {
  const d = new Date();
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  }).toUpperCase();
};

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "GOOD MORNING";
  if (h < 18) return "GOOD AFTERNOON";
  return "GOOD EVENING";
};

const WarRoom = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="px-6 md:px-12 py-10 md:py-14 max-w-[1400px] mx-auto space-y-14" data-testid="war-room">
      {/* Hero */}
      <header className="relative">
        <div className="flex items-center gap-3 mb-4">
          <span className="op-pulse-dot" />
          <span className="op-microcopy">SYSTEM ONLINE · {dateStr()}</span>
        </div>
        <div className="op-microcopy text-[#4A9EFF] mb-4">
          <EditableLabel labelKey="hero.system" defaultText="OPERATOR OS" />
        </div>
        <h1 className="text-white text-4xl md:text-6xl font-light tracking-tight leading-[1.05] mb-3">
          {greeting()}, <span className="text-white">
            <EditableLabel labelKey="hero.name" defaultText="ANTWAN" />
          </span>.
        </h1>
        <p className="text-[#B4BAD1] text-lg md:text-xl">
          <EditableLabel labelKey="hero.tagline" defaultText="Here's what matters today." />
        </p>
        <div className="op-hairline mt-8" />
      </header>

      {/* Primary focus — the only three things that matter */}
      <Top3 />

      {/* Quick capture — inline task-to-Todoist */}
      <InlineCapture />

      {/* Waiting On — live from Todoist @Waiting */}
      <WaitingOn />

      {/* Extras — hidden by default */}
      <div className="pt-4">
        <button
          onClick={() => setShowMore((v) => !v)}
          data-testid="warroom-more-toggle"
          className="w-full op-panel px-6 py-4 flex items-center justify-between text-left hover:border-[#4A9EFF]/40"
        >
          <div>
            <div className="op-mono text-[10px] tracking-[0.28em] text-[#6A7396] mb-1">MORE</div>
            <div className="text-white text-sm">
              {showMore ? "Hide" : "Show"} briefing, money, timeline, business pulse, and close-the-day
            </div>
          </div>
          {showMore ? <ChevronUp size={18} className="text-[#4A9EFF]" /> : <ChevronDown size={18} className="text-[#4A9EFF]" />}
        </button>
      </div>

      {showMore && (
        <div className="space-y-14" data-testid="warroom-more-content">
          <MorningBrief />
          <AskOperator />
          <TodoistTaskList
            mode="filter"
            filter="(overdue | p1) & !@Waiting & !@Top_3"
            code="TD"
            label="FLAGGED"
            caption="Overdue plus P1 — anything on fire (excludes Top 3 and Waiting)."
            testid="todoist-flagged"
            emptyText="Nothing overdue and no P1s open. Breathe."
            notConnectedText="Connect Todoist to surface overdue and P1 tasks here."
            showChips
            showPromote
          />
          <MoneyMoves />
          <DoNotDrop />
          <Timeline />
          <BusinessPulse />
          <EndOfDay />
        </div>
      )}
    </div>
  );
};

export default WarRoom;
